/* eur-energy-pop.js - the energy label opens in a pop-up on the page instead of a new tab, wherever the browser can
   show it there (user, 11 Oct 2026: "the energy labels should be popups if possible").
   Every energy class arrow the V5 pages draw links the product's label file (custom_fields.pdf_url):
     a.o2-earrow   product cards (homepage rails, product page "You might also like")
     a.ep-earrow   product page (buy box fallback, comparison table)
     a.ec5-earrow  basket and Saved for later
     a.mc5-earrow  pop-up basket (snippets/mini-cart.liquid, every page)
   One click handler for all of them, by what the label file is:
     image (jpg / png / webp / gif / svg, or     shown as it is
       an image host: Amplience)
     PDF the page may read (READ: Shopify files, the label part of page 1 drawn with PDF.js (cdnjs, loaded on the
       BSH, Samsung images, Electrolux, Icecat; first PDF label)
       on a computer any host that allows it)
     other file, on a computer (Beko, EPREL,     shown as an image if it is one (Safari shows a PDF as one), else the
       Hisense, Candy, Gorenje)                  browser's own viewer, framed
     anything else                               the link opens a new tab as before (LG and shop.samsung.com forbid
                                                 framing; phones cannot show a framed PDF)
   Hosts checked 11 Oct 2026 (CORS / X-Frame-Options) from the labels the homepage and product pages link.
   The pop-up always offers the file itself in a new tab too. The arrow keeps its href, so with no script, a
   modifier key or a middle click it still opens the file.
   Loaded by snippets/mini-cart.liquid (the header, every page), snippets/eur-home-assets.liquid (homepage),
   sections/eur-pdp-main.liquid and sections/eur-cart.liquid; runs once per page. */
(function () {
  'use strict';
  if (window.__eurEpop) return;
  window.__eurEpop = true;

  var d = document;
  var SEL = 'a.o2-earrow, a.ep-earrow, a.ec5-earrow, a.mc5-earrow';
  var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
  /* send Access-Control-Allow-Origin: * */
  var READ = /^(cdn\.shopify\.com|media3\.bsh-group\.com|images\.samsung\.com|api\.eluxmkt\.com|objects\.icecat\.biz)$/i;
  /* serve images without a file extension */
  var IMGHOST = /\.a\.bigcontent\.io$/i;
  /* frame-ancestors / X-Frame-Options forbid other sites */
  var NOFRAME = /((^|\.)lg\.com|^shop\.samsung\.com|^api\.eluxmkt\.com)$/i;
  var fine = !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
  var canDialog = typeof HTMLDialogElement === 'function' && 'showModal' in HTMLDialogElement.prototype;
  if (!canDialog) return;

  function mode(href) {
    var u;
    try { u = new URL(href, location.href); } catch (e) { return ''; }
    if (!/^https?:$/.test(u.protocol)) return '';
    if (/\.(png|jpe?g|webp|gif|svg)$/i.test(u.pathname) || IMGHOST.test(u.hostname)) return 'img';
    if (READ.test(u.hostname) || u.origin === location.origin) return 'pdf';
    /* a computer can fall back to framing it (open() does), so any other host is tried too */
    if (fine && !NOFRAME.test(u.hostname)) return 'pdf';
    return '';
  }

  var css = '' +
    '.eepop{width:min(560px,calc(100vw - 24px));max-width:none;max-height:calc(100vh - 24px);margin:auto;padding:0;border:0;border-radius:16px;' +
    'background:#fff;color:#0b1b3f;box-shadow:0 24px 64px rgba(11,27,63,.28);overflow:hidden;font:inherit}' +
    '.eepop::backdrop{background:rgba(11,27,63,.6)}' +
    '.eepop__hd{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 10px 10px 20px;border-bottom:1px solid #e3e7ef}' +
    '.eepop__t{margin:0;font-size:17px;font-weight:700;line-height:1.3;color:#0b1b3f}' +
    '.eepop__t span{display:block;font-size:13px;font-weight:500;color:#4a5568}' +
    '.eepop__x{display:flex;align-items:center;justify-content:center;flex:none;width:44px;height:44px;padding:0;border:0;border-radius:999px;background:#f2f4f8;color:#1d428b;cursor:pointer}' +
    '.eepop__x:focus-visible{outline:3px solid #1d428b;outline-offset:2px}' +
    '.eepop__b{display:flex;align-items:center;justify-content:center;min-height:240px;padding:16px;background:#fff}' +
    '.eepop__b img,.eepop__b canvas{display:block;max-width:100%;height:auto}' +
    '.eepop__b img{max-height:calc(100vh - 190px);width:auto}' +
    '.eepop__b iframe{display:block;width:100%;height:min(72vh,760px);border:0}' +
    '.eepop__msg{margin:0;font-size:14px;line-height:1.5;color:#4a5568;text-align:center}' +
    '.eepop__ft{margin:0;padding:12px 20px 16px;border-top:1px solid #e3e7ef;font-size:14px;line-height:1.4}' +
    '.eepop__ft a{color:#1d428b;font-weight:700;text-decoration:underline}';

  var dlg, body, title, link, token = 0, pdfjsP = null;

  function build() {
    if (dlg) return;
    var st = d.createElement('style');
    st.textContent = css;
    d.head.appendChild(st);
    dlg = d.createElement('dialog');
    dlg.className = 'eepop';
    dlg.setAttribute('aria-labelledby', 'eepop-t');
    dlg.innerHTML = '<div class="eepop__hd"><h2 class="eepop__t" id="eepop-t"></h2>' +
      '<button type="button" class="eepop__x" aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="eepop__b" aria-live="polite"></div>' +
      '<p class="eepop__ft"><a target="_blank" rel="noopener">Open the energy label in a new tab</a></p>';
    d.body.appendChild(dlg);
    body = dlg.querySelector('.eepop__b');
    title = dlg.querySelector('.eepop__t');
    link = dlg.querySelector('.eepop__ft a');
    dlg.querySelector('.eepop__x').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    /* the close event comes a moment after close(): if another label was opened since, leave it alone */
    dlg.addEventListener('close', function () { if (dlg.open) return; token++; body.textContent = ''; });
  }

  function msg(t) {
    var p = d.createElement('p');
    p.className = 'eepop__msg';
    p.textContent = t;
    body.textContent = '';
    body.appendChild(p);
  }

  function frame(href) {
    var f = d.createElement('iframe');
    f.src = href + (href.indexOf('#') < 0 ? '#view=Fit&toolbar=0' : '');
    f.title = 'Energy label';
    body.textContent = '';
    body.appendChild(f);
  }

  function loadPdfjs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (pdfjsP) return pdfjsP;
    pdfjsP = new Promise(function (res, rej) {
      var s = d.createElement('script');
      s.src = PDFJS + 'pdf.min.js';
      s.async = true;
      s.onload = function () {
        var L = window.pdfjsLib;
        if (!L) { rej(new Error('pdf.js')); return; }
        L.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
        res(L);
      };
      s.onerror = function () { rej(new Error('pdf.js')); };
      d.head.appendChild(s);
    });
    pdfjsP.catch(function () { pdfjsP = null; });
    return pdfjsP;
  }

  /* the printed part of a page drawn small: a box in page units (most label PDFs are an A4 page with the label in
     the middle of it), or null for the whole page */
  function inkBox(c, k) {
    var w = c.width, h = c.height, px;
    try { px = c.getContext('2d').getImageData(0, 0, w, h).data; } catch (e) { return null; }
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        if (px[i + 3] > 16 && (px[i] < 236 || px[i + 1] < 236 || px[i + 2] < 236)) {
          if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
      }
    }
    if (x1 < 0) return null;
    var pad = Math.round(Math.max(x1 - x0, y1 - y0) * 0.03) + 2;
    x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad); x1 = Math.min(w, x1 + pad); y1 = Math.min(h, y1 + pad);
    if ((x1 - x0) * (y1 - y0) > w * h * 0.85) return null;
    return { x: x0 / k, y: y0 / k, w: (x1 - x0) / k, h: (y1 - y0) / k };
  }

  /* page 1 of the PDF (the label; "COMBINED" files put the information sheet after it): drawn small once to find
     the label on the page, then only the label, sharp, fitted to the pop-up */
  function drawPdf(href, alt, t) {
    var page;
    return loadPdfjs()
      /* one plain GET (labels are small): byte-range requests need a CORS preflight some label hosts do not answer */
      .then(function (L) { return L.getDocument({ url: href, withCredentials: false, disableRange: true, disableStream: true }).promise; })
      .then(function (pdf) { return pdf.getPage(1); })
      .then(function (p) {
        page = p;
        var v1 = page.getViewport({ scale: 1 }), k = Math.min(1, 700 / Math.max(v1.width, v1.height));
        var pv = page.getViewport({ scale: k }), pc = d.createElement('canvas');
        pc.width = Math.ceil(pv.width); pc.height = Math.ceil(pv.height);
        return page.render({ canvasContext: pc.getContext('2d'), viewport: pv }).promise.then(function () {
          return inkBox(pc, k) || { x: 0, y: 0, w: v1.width, h: v1.height };
        });
      })
      .then(function (b) {
        if (t !== token) return;
        var availW = Math.max(200, body.clientWidth - 32), availH = Math.max(240, window.innerHeight - 190);
        var s = Math.min(availW / b.w, availH / b.h);
        var dpr = Math.min(window.devicePixelRatio || 1, 2.5), r = s * dpr;
        var vp = page.getViewport({ scale: r, offsetX: -b.x * r, offsetY: -b.y * r });
        var c = d.createElement('canvas');
        c.width = Math.floor(b.w * r);
        c.height = Math.floor(b.h * r);
        c.style.width = Math.floor(b.w * s) + 'px';
        c.setAttribute('role', 'img');
        c.setAttribute('aria-label', alt);
        return page.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise.then(function () {
          if (t !== token) return;
          body.textContent = '';
          body.appendChild(c);
        });
      });
  }

  function open(a, how) {
    build();
    var href = a.href, t = ++token;
    /* a double oven's arrows (22 Oct 2026) say which cavity: "Energy class B, second oven, ..." */
    var m = /Energy class ([A-G]\+{0,3})(?:, (main|second|third|fourth) oven)?/.exec(a.getAttribute('aria-label') || '');
    var cls = m ? m[1] : '';
    var alt = 'EU energy label' + (cls ? ', energy class ' + cls : '') + (m && m[2] ? ', ' + m[2] + ' oven' : '');
    title.innerHTML = 'Energy label';
    if (cls) { var sp = d.createElement('span'); sp.textContent = 'Energy efficiency class ' + cls + (m && m[2] ? ', ' + m[2] + ' oven' : ''); title.appendChild(sp); }
    link.href = href;
    if (how === 'img') {
      var im = d.createElement('img');
      im.alt = alt;
      im.src = href;
      body.textContent = '';
      body.appendChild(im);
    } else {
      msg('Loading the energy label…');
      drawPdf(href, alt, t).catch(function () {
        if (t !== token) return;
        /* not a PDF the page may read: an image without an extension, else framed (computers only) */
        var im = new Image();
        im.alt = alt;
        im.onload = function () { if (t !== token) return; body.textContent = ''; body.appendChild(im); };
        im.onerror = function () {
          if (t !== token) return;
          if (fine && !NOFRAME.test(new URL(href, location.href).hostname)) frame(href);
          else msg('The label could not be shown here. Use the link below to open it.');
        };
        im.src = href;
      });
    }
    if (!dlg.open) dlg.showModal();
  }

  /* screen readers: these arrows now open a dialog, not a new tab */
  function prep(root) {
    Array.prototype.forEach.call((root || d).querySelectorAll(SEL), function (a) {
      if (a.hasAttribute('data-eepop')) return;
      a.setAttribute('data-eepop', '');
      if (!mode(a.href)) return;
      a.setAttribute('aria-haspopup', 'dialog');
      var l = a.getAttribute('aria-label');
      if (l) a.setAttribute('aria-label', l.replace(/ in a new tab/i, ''));
    });
  }

  d.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest(SEL) : null;
    if (!a) return;
    var how = mode(a.href);
    if (!how) return;
    e.preventDefault();
    open(a, how);
  });

  function start() {
    prep();
    var tm = 0;
    new MutationObserver(function () {
      clearTimeout(tm);
      tm = setTimeout(function () { prep(); }, 200);
    }).observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
